import { defineComponent as w, computed as l, openBlock as t, createElementBlock as a, normalizeClass as o, Fragment as r, renderList as m, unref as v, createElementVNode as k, createVNode as z, Transition as C, withCtx as L, toDisplayString as i, createCommentVNode as c } from "vue";
import { useI18n as j, useLocale as D } from "@ds/plugin";
import E from "../../../translations/generic.translations.js";
import { useCountdown as I } from "../useCountdown.js";
const N = ["aria-label", "datetime"], S = {
  key: 0,
  class: "self-center"
}, T = {
  key: 0,
  class: "text-static-default-low label-small-bold mt-4 flex justify-center"
}, O = /* @__PURE__ */ w({
  name: "RevCountdown",
  __name: "Countdown",
  props: {
    ariaLabel: {},
    date: {},
    maxUnit: {},
    labels: {},
    size: {},
    mood: {}
  },
  setup(e) {
    const d = j(), u = D(), f = l(() => e.ariaLabel && e.ariaLabel.length ? e.ariaLabel : d(E.countdownEnd, {
      endDate: Intl.DateTimeFormat(u.value, {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      }).format(e.date)
    })), b = l(() => ({ date: e.date, maxUnit: e.maxUnit, labels: e.labels })), h = I(b);
    return (U, V) => (t(), a("time", {
      "aria-label": f.value,
      class: o([
        "flex flex-wrap justify-center",
        e.size === "small" ? "gap-2" : "gap-4",
        e.mood === "main" ? "mood-main" : "mood-inverse"
      ]),
      datetime: e.date.toISOString(),
      role: "timer"
    }, [
      (t(!0), a(r, null, m(v(h), ({ label: n, value: y }, x) => (t(), a("span", {
        key: `digits-${x}`,
        "aria-hidden": !0
      }, [
        k("span", {
          class: o(["bg-static-default-low text-static-default-hi flex w-full items-center justify-center overflow-hidden tabular-nums", {
            "rounded-xs caption-bold h-24 p-4": e.size === "small",
            "rounded-sm heading-1 h-40 px-8 py-4": e.size === "medium",
            "rounded-sm punchline-sans h-52 px-8 py-2 md:h-60": e.size === "large"
          }])
        }, [
          (t(!0), a(r, null, m(y?.split(""), (s, g) => (t(), a("span", {
            key: `digit-${g}`,
            class: "relative inline-block h-full w-[0.6em]"
          }, [
            z(C, {
              "enter-active-class": "motion-safe:transition-all motion-safe:duration-200 motion-safe:ease-[cubic-bezier(0.332,1.955,0.64,1)]",
              "enter-from-class": "motion-safe:-translate-y-40",
              "leave-active-class": "motion-safe:absolute motion-safe:transition-all motion-safe:duration-100 motion-safe:ease-in",
              "leave-to-class": "motion-safe:translate-y-40",
              mode: "out-in"
            }, {
              default: L(() => [
                (t(), a("span", {
                  key: s,
                  class: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
                }, i(s), 1))
              ]),
              _: 2
            }, 1024)
          ]))), 128)),
          e.size === "small" && n ? (t(), a("span", S, i(n), 1)) : c("", !0)
        ], 2),
        e.size !== "small" && n ? (t(), a("span", T, i(n), 1)) : c("", !0)
      ]))), 128))
    ], 10, N));
  }
});
export {
  O as default
};
